import { render } from "./settings-area.vue?vue&type=template&id=ec530828"
import script from "./settings-area.vue?vue&type=script&lang=js"
export * from "./settings-area.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__